import { render } from "./HomeView.vue?vue&type=template&id=06bf14e8&scoped=true"
import script from "./HomeView.vue?vue&type=script&lang=js"
export * from "./HomeView.vue?vue&type=script&lang=js"

import "./HomeView.vue?vue&type=style&index=0&id=06bf14e8&scoped=true&lang=css"

import exportComponent from "D:\\mnry7\\Documents\\front-saberes\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06bf14e8"]])

export default __exports__